import config from '../../config.js'

export const contractAddresses = {
  blok: {
    137: config.BLOK_CONTRACT,
    1337: config.BLOK_CONTRACT
  },
  blokStaking: {
    137: config.BLOK_POOL_CONTRACT,
    1337: config.BLOK_POOL_CONTRACT
  },
}

export const supportedPools = [
  {
    pid: 0,
    lpAddress: config.BLOK_CONTRACT,
    stakingTokenAddresses: {
      137: config.BLOK_CONTRACT,
      1337: config.BLOK_CONTRACT
    },
    rewardTokenAddresses: {
      137: config.BLOK_CONTRACT,
      1337: config.BLOK_CONTRACT
    },
    stakingContractAddresses: {
      137: config.BLOK_POOL_CONTRACT,
      1337: config.BLOK_POOL_CONTRACT
    },
    name: 'BLOK-BLOK Pool',
    symbol: 'BLOK',
    tokenSymbol: 'BLOK',
    icon: "https://polygonscan.com/token/images/bloktopia_32.png",
  },
]